import { render, staticRenderFns } from "./mo-input-pill.html?vue&type=template&id=97867cb6&scoped=true&external"
import script from "./mo-input-pill.ts?vue&type=script&lang=ts&external"
export * from "./mo-input-pill.ts?vue&type=script&lang=ts&external"
import style0 from "./mo-input-pill.vue?vue&type=style&index=0&id=97867cb6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97867cb6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/3/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97867cb6')) {
      api.createRecord('97867cb6', component.options)
    } else {
      api.reload('97867cb6', component.options)
    }
    module.hot.accept("./mo-input-pill.html?vue&type=template&id=97867cb6&scoped=true&external", function () {
      api.rerender('97867cb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-input-pill/mo-input-pill.vue"
export default component.exports